import { render } from "./LookalikeLocations.vue?vue&type=template&id=41189240&scoped=true"
import script from "./LookalikeLocations.vue?vue&type=script&lang=js"
export * from "./LookalikeLocations.vue?vue&type=script&lang=js"

import "./LookalikeLocations.vue?vue&type=style&index=0&id=41189240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41189240"]])

export default __exports__